import type { IFetchOptionsRequestPayload, IOptionsRequestKey } from './types';

export const toOptionsRequestKey = ({ list, search, page }: IFetchOptionsRequestPayload): IOptionsRequestKey => ({
  list,
  search: (search ?? '').trim(),
  page: page ?? 1,
});
